import Image from 'next/image';
import styled, { css } from 'styled-components';

import useDevice from '@hooks/useDevice';
import { device } from '@styles/mediaQuery';
import { Container } from '@components/atoms';

function ThankYouPageContent() {
  const { isMobile, isTablet } = useDevice();

  return (
    <Container>
      <StyledSection $isMobile={isMobile} $isTablet={isTablet}>
        <Wrapper>
          <StyledImg
            fill
            quality={80}
            alt="quality-service-is-our-low-image"
            src="/images/video-bg-1x.webp"
            priority
          />

          <OverlayWrapper>
            <StyledLogo
              src="/icons/logo_full_white.svg"
              alt="logo"
              width={219}
              height={34}
            />

            <StyledTitle>Thank you!</StyledTitle>
            <Description>Our manager will contact you soon.</Description>
          </OverlayWrapper>
        </Wrapper>
      </StyledSection>
    </Container>
  );
}

const Description = styled.span`
  display: flex;
  flex-direction: column;

  line-height: 25px;

  color: ${({ theme }) => theme.colors.athensGray};

  ${device.mobileL(css`
    font-size: 17px;
  `)};

  ${device.tablet(css`
    font-size: 25px;
  `)};
`;

const StyledTitle = styled.span`
  font-size: 20px;
  font-weight: 600;

  ${device.mobileL(css`
    font-size: 25px;
    padding-bottom: 10px;
  `)};

  ${device.tablet(css`
    font-size: 50px;
  `)};
`;

const StyledLogo = styled(Image)`
  height: 15px;
  width: 100px;
  margin-bottom: 20px;

  ${device.mobileL(css`
    height: 25px;
    width: 150px;
  `)};

  ${device.tablet(css`
    margin-bottom: 10px;

    height: 40px;
    width: 200px;
  `)};
`;

const OverlayWrapper = styled.div`
  width: 100%;
  height: 100%;

  position: absolute;
  top: 0;
  left: 0;

  display: flex;
  flex-direction: column;

  align-items: center;
  justify-content: center;

  color: ${({ theme }) => theme.colors.white};
`;

const Wrapper = styled.div`
  position: relative;

  width: 100%;
  height: 170px;

  overflow: hidden;
  border-radius: 16px;

  background-color: ${({ theme }) => theme.colors.black};

  z-index: 1;

  ${device.mobileL(css`
    height: 205px;
  `)}

  ${device.tablet(css`
    height: 320px;
  `)}


  ${device.laptopS(css`
    height: 344px;
  `)}

  ${device.laptopL(css`
    height: 484px;
  `)}
`;

const StyledImg = styled(Image)`
  width: 100%;
  height: 100%;
  object-fit: fill;

  position: absolute;
  top: 0;
  left: 0;
`;

const StyledSection = styled.section<{
  $isMobile: boolean;
  $isTablet: boolean;
}>`
  width: 100%;

  position: relative;

  display: flex;
  flex-direction: column;

  padding-top: ${({ $isMobile }) => ($isMobile ? '116px' : '130px')};

  height: ${({ $isMobile, $isTablet }) => {
    if ($isMobile) return 'calc(100vh - 360px)';
    if ($isTablet) return 'calc(100vh - 355px)';

    return 'calc(100vh - 279px)';
  }};

  margin-bottom: 100px;
`;

export default ThankYouPageContent;
